module.exports = __webpack_public_path__ + "static/media/imgBM.e626d75c.svg";